<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const { $bus, $constants, $stores, $attrs } = proxy;
const currentPage = ref(0);
const pageSize = 10; // adapte si nécessaire

const transactionsState = computed(() => $stores.transactions?.state?.list_all);

const totalPages = computed(() => {
  const total = transactionsState.value?.total || 0;
  return Math.ceil(total / pageSize);
});

function changePage(page) {
  if (page < 0) return;
  if (page >= totalPages.value) return;

  currentPage.value = page;

  $bus.emit($constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH, {
    page,
    userId: $attrs.userId
  });
}

/**
 * Optionnel :
 * reset la page quand on relance un refresh global
 */
watch(
  () => transactionsState.value?.resetPagination,
  (val) => {
    if (val) {
      currentPage.value = 0;
    }
  }
);
</script>

<template>
  <VBusHelper
    :emitOnMounted="$constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH"
    :dataOnMounted="{ userId: $attrs.userId }"
  />
  <TransactionsLoadingError
    @refresh="() => $bus.emit($constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH)"
    v-if="$stores.transactions?.state?.list_all?.error"
  >
    <template #errorDescription>
      {{ $stores.transactions?.state?.list_all?.error }}
    </template>
  </TransactionsLoadingError>
  <div
    v-else-if="$stores.transactions?.state?.list_all?.list.length"
    class="space-y-4"
  >
    <TransactionItem
      @click="$bus.emit($constants.EVENTS.TRANSACTIONS.DETAIL.SHOW, trx)"
      v-for="trx in $stores.transactions?.state?.list_all?.list"
      :item="trx"
    />

    <div class="px-6 py-3 bg-gray-50 flex justify-between items-center">
      <span class="text-sm text-gray-700"
        >Page {{ currentPage + 1 }} of {{ totalPages }}</span
      >
      <div class="space-x-2">
        <button
          @click="changePage(currentPage - 1)"
          class="px-3 py-1 bg-purple-100 text-purple-700 rounded hover:bg-purple-200"
        >
          &lt;
        </button>
        <button
          @click="changePage(currentPage + 1)"
          class="px-3 py-1 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
        >
          &gt;
        </button>
      </div>
    </div>
  </div>
  <div
    v-else-if="$stores.transactions?.state?.list_all?.loading"
    class="space-y-4 shimmerContainer"
  >
    <TransactionItem v-for="trx in 9" :item="trx" />
  </div>
  <EmptyTransactions
    @refresh="
      () =>
        $bus.emit($constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH, {
          page: currentPage,
          userId: $attrs.userId
        })
    "
    v-else
  />
</template>
